import { useSuspenseQuery } from '@tanstack/react-query';
import { routesCountQueryOptions } from '#api/routes.queries.ts';
import { useCapabilities } from '#global/context/capabilities/useCapabilities.ts';

export function useSuspenseIsRoutesLimitReached() {
  const { data: routesCount } = useSuspenseQuery(routesCountQueryOptions);
  const { capabilities } = useCapabilities();

  // This should be defined if the routeCount query succeeds
  if (!capabilities) {
    throw new Error('Could not get route count and/or route limit');
  }
  const { routesLimit } = capabilities;

  return {
    isLimitReached: routesCount >= routesLimit,
    routesLimit,
  };
}
